module.exports = __webpack_public_path__ + "img/qr.38436463.png";